export default __webpack_public_path__ + "static/media/soleil_regular.ca5f9f5c.woff";